export default __webpack_public_path__ + "../subsite.html";